import SimpleLink from 'core/components/SimpleLink'
import Text from 'pf9-ui-components/built/elements/Text'
import React, { useState } from 'react'
import Button from 'pf9-ui-components/built/elements/button/Button'
import Modal from 'pf9-ui-components/built/elements/modal/Modal'
import { makeStyles } from '@material-ui/core/styles'
import Theme from 'core/themes/model'
import Tooltip from 'core/elements/tooltip'
import { GPUMemoryCellComponent } from '../capacity-and-health/ListWorkerNodes'

export const GPU_KEY_TO_LABEL = {
  model: 'Model',
  partitioningStrategy: 'Partitioning Strategy',
  details: 'Details',
  count: 'Count',
  replicas: 'Replicas',
  memory: 'Memory',
}

const GPUDetailsModal = ({ item, value }: { item: any; value: boolean }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  if (!value) {
    return <Text variant="body2">-</Text>
  }

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="GPU Details"
        footer={
          <Button variant="primary" onClick={() => setOpen(false)}>
            Close
          </Button>
        }
        panel="dialog"
      >
        <div className={classes.container}>
          {Object.entries(item?.gpu).map(([key, value]) =>
            Object.keys(GPU_KEY_TO_LABEL).includes(key) ? (
              <>
                <Text variant="caption1">{GPU_KEY_TO_LABEL[key]}</Text>
                {key === 'memory' ? (
                  <GPUMemoryCellComponent value={value} />
                ) : (
                  <Text variant="body2">{String(value)}</Text>
                )}
              </>
            ) : null,
          )}
        </div>
      </Modal>
      <Text variant="body2">
        <Tooltip message="See GPU details" align={{ vertical: 'bottom', horizontal: 'middle' }}>
          <SimpleLink onClick={() => setOpen(true)}>
            <b>{value}</b>
          </SimpleLink>
        </Tooltip>
      </Text>
    </>
  )
}

export default GPUDetailsModal

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
  },
}))
